import { render, staticRenderFns } from "./JugadoresTable.view.vue?vue&type=template&id=5c64e990&scoped=true"
import script from "./JugadoresTable.view.vue?vue&type=script&lang=js"
export * from "./JugadoresTable.view.vue?vue&type=script&lang=js"
import style0 from "./JugadoresTable.view.vue?vue&type=style&index=0&id=5c64e990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c64e990",
  null
  
)

export default component.exports